import { dialogTitleClasses as h, createTheme as A } from "@mui/material";
import { jsx as g } from "react/jsx-runtime";
import { T as W, I as H, W as D, A as _, C as U, a as L } from "./Warning-RmgMSYCd.js";
import { useLayoutEffect as V, useEffect as F, useState as f, useMemo as G, useRef as N } from "react";
const v = {
  primary: {
    main: "#7939F7",
    dark: "#3B00C3",
    light: "#E4D7FD",
    contrastText: "#FFFFFF"
  },
  secondary: {
    main: "#2FB6BC",
    dark: "#009695",
    light: "#ACE2E4",
    contrastText: "#FFFFFF"
  },
  error: {
    main: "#E1615C",
    dark: "#AA3032",
    light: "#FF9289",
    contrastText: "#FFFFFF"
  },
  success: {
    main: "#41C390",
    dark: "#009262",
    light: "#87E4BB",
    contrastText: "#FFFFFF"
  },
  warning: {
    main: "#ED6C02",
    dark: "#E65100",
    light: "#FFD093",
    contrastText: "#FFFFFF"
  }
}, j = {
  mode: "light",
  ...v,
  background: {
    paper: "#FAFAFA",
    default: "#FFFFFF"
  },
  divider: "#EDEBE6",
  text: {
    primary: "#333333",
    secondary: "#575756"
  }
}, X = {
  mode: "dark",
  ...v,
  background: {
    paper: "#2A2A2A",
    default: "#333333"
  }
}, b = {
  light: j,
  dark: X
}, y = {
  values: {
    xs: 0,
    sm: 600,
    md: 905,
    lg: 1240,
    xl: 1440
  }
}, Y = (e) => e.main !== void 0, J = (e) => Y(e) ? e : void 0, S = {
  MuiAppBar: {
    defaultProps: {
      position: "sticky",
      elevation: 0,
      color: "inherit"
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        boxShadow: `inset 0 -1px 0 0 ${e.palette.divider}`,
        backgroundImage: "none",
        backgroundColor: e.palette.background.default
      })
    }
  },
  MuiButtonBase: {
    defaultProps: {
      // used for accessibility
      // disableRipple: true,
    }
  },
  MuiButton: {
    defaultProps: {
      // used for accessibility
      // disableRipple: true,
      variant: "contained"
    },
    styleOverrides: {
      root: {},
      outlined: {},
      sizeSmall: ({ theme: e }) => ({
        fontSize: e.typography.button.fontSize
      })
    }
  },
  MuiIconButton: {
    defaultProps: {
      color: "inherit"
    }
  },
  MuiTextField: {
    defaultProps: {
      size: "small"
    }
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  MuiTreeView: {
    defaultProps: {
      defaultCollapseIcon: /* @__PURE__ */ g(L, {}),
      defaultExpandIcon: /* @__PURE__ */ g(U, {})
    }
  },
  MuiAlert: {
    defaultProps: {
      iconMapping: {
        error: /* @__PURE__ */ g(_, { fontSize: "inherit" }),
        warning: /* @__PURE__ */ g(D, { fontSize: "inherit" }),
        info: /* @__PURE__ */ g(H, { fontSize: "inherit" }),
        success: /* @__PURE__ */ g(W, { fontSize: "inherit" })
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ ownerState: e }) => ({
        [`& .${h.root}`]: {
          minHeight: e.fullScreen ? 72 : void 0
        }
      })
    }
  },
  MuiDialogTitle: {
    defaultProps: {
      component: "h5"
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        ...e.typography.h5,
        backgroundColor: J(e.palette.primary)?.main,
        color: e.palette.common.white,
        padding: e.spacing(2)
      })
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ ownerState: e, theme: t }) => ({
        padding: t.spacing(3, 2),
        // The MUI library adds this class with precise specificity when there are no dividers.
        // The class has the declaration `padding-top: 0` which will be a higher priority than the above padding override for this component.
        // We override this class here such that the component will always have a `padding-top` regardless of dividers and the internal library implementation.
        [`.${h.root} + &`]: {
          paddingTop: t.spacing(3)
        },
        // override styles when dividers are used
        // - we don't need a divider at the top
        borderTop: e.dividers ? 0 : void 0
      })
    }
  },
  MuiDialogContentText: {
    defaultProps: {
      color: "text.primary"
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        padding: e.spacing(2)
      })
    }
  },
  MuiTooltip: {
    defaultProps: {
      arrow: !0,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                // the tooltip container's has 14px padding to its anchor.
                // an optional 6px arrow is sharing the padding.
                //
                // when the arrow doesn't show up, the tooltip is 14px away from the anchor.
                // when the arrow shows up within the padding, the arrow is 8px (1 spacing unit) away from the anchor.
                //
                // so, there we decrease by 6px to make the arrow closer the anchor, and still leave 2px spacing.
                // when the arrow doesn't show up, the tooltip can have 8px (1 spacing unit) spacing.
                offset: [0, -6]
              }
            }
          ]
        }
      }
    },
    styleOverrides: {
      arrow: ({ theme: e }) => ({
        color: e.palette.text.primary
      }),
      tooltip: ({ theme: e }) => ({
        backgroundColor: e.palette.text.primary
      })
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "hover"
    },
    styleOverrides: {
      root: {
        cursor: "pointer"
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      list: ({ theme: e }) => ({
        backgroundColor: e.palette.background.default
      })
    }
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        backgroundColor: e.palette.background.default,
        borderColor: e.palette.divider,
        borderWidth: 0.5,
        borderStyle: "solid"
      })
    }
  },
  MuiCardActions: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        padding: e.spacing(2)
      })
    }
  },
  MuiCardActionArea: {
    styleOverrides: {
      root: ({ ownerState: e, theme: t }) => ({
        opacity: e.disabled ? t.palette.action.disabledOpacity : void 0
      })
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        // required because a color in our palette is much lighter than the default
        // and this leads to the divider line being too faint
        borderBottom: `1px solid ${e.palette.grey[300]}`
      })
    }
  },
  MuiDataGrid: {
    // required because a color in our palette is much lighter than the default
    // and this leads to the divider line being too faint
    styleOverrides: {
      root: ({ theme: e }) => ({
        border: `1px solid ${e.palette.grey[300]}`
      }),
      cell: ({ theme: e }) => ({
        borderBottom: `1px solid ${e.palette.grey[300]}`
      }),
      columnHeaders: ({ theme: e }) => ({
        borderBottom: `1px solid ${e.palette.grey[300]}`
      })
    }
  }
}, z = [
  "none",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)"
], C = {
  borderRadius: 0
}, M = 8, K = '"ProximaNova", "Helvetica Neue", "Helvetica", "Arial", sans-serif', q = 14, o = 16, Q = 300, d = 400, c = 600, u = 700, k = {
  fontFamily: K,
  fontSize: q,
  htmlFontSize: o,
  fontWeightLight: Q,
  fontWeightRegular: d,
  fontWeightMedium: c,
  fontWeightBold: u,
  h3: {
    fontWeight: u,
    fontSize: `${34 / o}rem`,
    lineHeight: 1.4
  },
  h4: {
    fontWeight: u,
    fontSize: `${24 / o}rem`,
    lineHeight: 1.4
  },
  h5: {
    fontWeight: c,
    fontSize: `${20 / o}rem`,
    lineHeight: 1.4
  },
  h6: {
    fontWeight: c,
    fontSize: `${16 / o}rem`,
    lineHeight: 1.4
  },
  subtitle1: {
    fontWeight: c,
    fontSize: `${14 / o}rem`,
    lineHeight: 1.5
  },
  subtitle2: {
    fontWeight: c,
    fontSize: `${12 / o}rem`,
    lineHeight: 1.5
  },
  body1: {
    fontWeight: d,
    fontSize: `${14 / o}rem`,
    lineHeight: 1.5
  },
  body2: {
    fontWeight: d,
    fontSize: `${12 / o}rem`,
    lineHeight: 1.5
  },
  caption: {
    fontWeight: d,
    fontSize: `${10 / o}rem`,
    lineHeight: 1.66
  },
  overline: {
    fontWeight: d,
    fontSize: `${12 / o}rem`,
    lineHeight: 1.66,
    textTransform: "capitalize"
  },
  button: {
    fontWeight: u,
    fontSize: `${14 / o}rem`,
    lineHeight: 1.75,
    textTransform: "none"
  }
}, m = (e) => A({ palette: e, typography: k, shadows: z, shape: C, breakpoints: y, spacing: M, components: S }), c0 = {
  light: m(b.light),
  dark: m(b.dark)
}, Z = "moata", e0 = "data-mui-color-scheme", u0 = A({
  cssVariables: {
    // Set a prefix here, so that all Moata Apps would have consistent variable names.
    cssVarPrefix: Z,
    // Always return `false` to generate all CSS variables in the theme,
    // so that all of them can be referenced in css/scss files.
    shouldSkipGeneratingVar: () => !1,
    // The color scheme will be applied to the element with this attribute.
    // This will be set on the `html` element by default, so that all components can inherit it.
    // child elements can override the color scheme by setting this attribute with the theme name on themselves.
    colorSchemeSelector: e0,
    disableCssColorScheme: !0
  },
  defaultColorScheme: "light",
  colorSchemes: {
    light: {
      palette: b.light
    },
    dark: {
      palette: b.dark
    }
  },
  typography: k,
  shadows: z,
  shape: C,
  breakpoints: y,
  spacing: M,
  components: S
});
var t0 = function() {
}, $ = typeof window < "u", r0 = $ ? V : F, w = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function o0() {
  var e = f(null), t = e[0], l = e[1], a = f(w), s = a[0], p = a[1], i = G(function() {
    return new window.ResizeObserver(function(n) {
      if (n[0]) {
        var r = n[0].contentRect, x = r.x, E = r.y, T = r.width, O = r.height, R = r.top, B = r.left, P = r.bottom, I = r.right;
        p({ x, y: E, width: T, height: O, top: R, left: B, bottom: P, right: I });
      }
    });
  }, []);
  return r0(function() {
    if (t)
      return i.observe(t), function() {
        i.disconnect();
      };
  }, [t]), [l, s];
}
const p0 = $ && typeof window.ResizeObserver < "u" ? o0 : function() {
  return [t0, w];
}, i0 = new RegExp(
  "^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+,]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
  "i"
), a0 = (e) => !!i0.test(e), n0 = ({
  imageUrl: e,
  crop: t = "fill",
  gravity: l,
  width: a,
  height: s,
  roundTo: p = 100
}) => {
  if (e === void 0)
    return;
  if (!a0(e) || new URL(e).hostname !== "res.cloudinary.com") return e;
  const i = e.split(/(image\/upload\/)/);
  if (i.length > 1) {
    const n = i.slice(0, 2).join(""), r = i[2].split(/([a-z]_[a-z0-9]+)(,[a-z]_[a-z0-9]+)*\//).reverse()[0], x = [];
    return x.push(`c_${t}`), l !== void 0 && x.push(`g_${l}`), a !== void 0 && a !== 0 && x.push(`w_${Math.ceil(a / p) * p}`), s !== void 0 && s !== 0 && x.push(`h_${Math.ceil(s / p) * p}`), `${n}${x.length > 0 ? `${x.join(",")}/` : ""}${r}`;
  }
  return e;
}, x0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgEAEAABkAFaLhbucAAAAASUVORK5CYII=", b0 = ({
  ...e
}) => {
  const t = N({ width: 0, height: 0 }), [l, a] = f(x0), [s, { width: p, height: i }] = p0();
  return F(() => {
    if (t.current.width >= p && t.current.height >= i)
      return () => null;
    const n = n0({ ...e, width: p, height: i });
    if (n === void 0)
      return () => null;
    const r = new Image();
    return r.onload = () => {
      t.current.width = p, t.current.height = i, a(n);
    }, r.src = n, () => {
      r.onload = null;
    };
  }, [e, p, i]), { imageRef: s, transformedImageUrl: l };
};
export {
  u0 as cssVarsTheme,
  x0 as preloadImage,
  c0 as themes,
  b0 as useCloudinaryImage
};
//# sourceMappingURL=index.js.map
